import React, { useCallback } from 'react';

import { type Person } from '@clubspark-node/clubspark-tennis-types';
import { create, show, useModal } from '@ebay/nice-modal-react';

import PlayerProfileDialog from 'components/dialogs/playerProfileDialog/PlayerProfileDialog';

import { type ParticipantOrId, usePlayerSelect } from './ChoosePlayer';

interface ModalProps {
  participantId: string;
  person?: Person;
  tournamentId?: string;
}

const Modal = create(({ participantId }: ModalProps) => {
  const modal = useModal();

  return <PlayerProfileDialog isOpen={modal.visible} participantId={participantId} onClose={modal.hide} />;
});

/**
 * Open a player profile dialog with chosen participant(s)
 */
export const usePlayersProfileDialog = () => {
  const choosePlayers = usePlayerSelect();
  return useCallback(
    async (participants: ParticipantOrId[]) => {
      const participant = await choosePlayers(participants);
      if (participant) {
        show(Modal, {
          participantId: participant.participantId,
        });
      }
    },
    [choosePlayers],
  );
};
